import { render, staticRenderFns } from "./VerDetallePlanPreventivoModal.vue?vue&type=template&id=2b271ad4&"
import script from "./VerDetallePlanPreventivoModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetallePlanPreventivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports